var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*mail 標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.sqlRunner.mail_subject.$error ? false : null,
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.mail_subject,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "mail_subject", $$v);
      },
      expression: "sqlRunner.mail_subject"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.sqlRunner.mail_subject.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "mail 內容"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.mail_content,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "mail_content", $$v);
      },
      expression: "sqlRunner.mail_content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "mail 收件人"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.mail_to,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "mail_to", $$v);
      },
      expression: "sqlRunner.mail_to"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "mail 副本"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.mail_cc,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "mail_cc", $$v);
      },
      expression: "sqlRunner.mail_cc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "mail 密件副本"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.mail_bcc,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "mail_bcc", $$v);
      },
      expression: "sqlRunner.mail_bcc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "描述"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.description,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "description", $$v);
      },
      expression: "sqlRunner.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*cronjob 設定"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.sqlRunner.cron_schedule.$error ? false : null,
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.cron_schedule,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "cron_schedule", $$v);
      },
      expression: "sqlRunner.cron_schedule"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.sqlRunner.cron_schedule.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*SQL"
    }
  }, [_c('editor', {
    attrs: {
      "disabled": _vm.isReadonly,
      "width": "100%",
      "height": "200px",
      "lang": "sql",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.sqlRunner.sql,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "sql", $$v);
      },
      expression: "sqlRunner.sql"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.sqlRunner.sql.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*樣式"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "state": _vm.v$.sqlRunner.format.$error ? false : null,
      "options": _vm.formatOptions,
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.format,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "format", $$v);
      },
      expression: "sqlRunner.format"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.sqlRunner.format.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*起始時間"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.startAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "date", $$v);
      },
      expression: "startAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.startAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "time", $$v);
      },
      expression: "startAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.time.HH.$error || !_vm.v$.startAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*結束時間"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.startAt.$invalid
      },
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.endAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "date", $$v);
      },
      expression: "endAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.startAt.time.HH.$error || _vm.v$.startAt.time.mm.$error || _vm.v$.startAt.date.beforeEndAt.$invalid
      }],
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.endAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "time", $$v);
      },
      expression: "endAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.time.HH.$error || !_vm.v$.endAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "is_enabled", $$v);
      },
      expression: "sqlRunner.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "無資料時是否寄送"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.sqlRunner.send_when_empty,
      callback: function callback($$v) {
        _vm.$set(_vm.sqlRunner, "send_when_empty", $$v);
      },
      expression: "sqlRunner.send_when_empty"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }